module.exports = __webpack_public_path__ + "static/media/Flights.8947f4a0.svg";